import Vue from 'vue';
import Vuex from 'vuex';

import { main } from './main/main';
import { authentication } from './authentication/authentication';
import { snackbar } from './snackbar/snackbar';
import { modal } from './modal/modal';
import { pessoa } from './pessoa/pessoa';
import { empresa } from './empresa/empresa';
import { obra } from './obra/obra';
import { boleto } from './boleto/boleto';
import { entrada } from './entrada/entrada';
import { saida } from './saida/saida';
import { valor } from './valor/valor';
import { material } from './material/material';
// import { categoria } from './categoria/categoria';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    main,
    authentication,
    snackbar,
    modal,
    pessoa,
    empresa,
    obra,
    boleto,
    entrada,
    saida,
    valor,
    material,
    // categoria,
  },
});
